import React, { useEffect, useState } from 'react';

import { getPrivateAccessData } from '@/api/properties';
import { getPropertyAddress } from '@/utils/properties';
import { Link } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';

const PropertySharingDetails = ({ property, dashboardLinkPrefix }) => {
  const [activeSharing, setActiveSharing] = useState();
  const [fetching, setFetching] = useState(true);
  const [sharingError, setSharingError] = useState();

  const fetchPrivateAccessData = async () => {
    setFetching(true);
    const [error, response] = await getPrivateAccessData(
      property?.boligmappaNumber
    );

    if (error && !response) {
      setSharingError(error);
    } else {
      setActiveSharing(response.active);
    }
    setFetching(false);
  };

  useEffect(() => {
    if (property?.owned !== false) {
      fetchPrivateAccessData();
    } else {
      setFetching(false);
    }
  }, [property]);

  if (fetching || sharingError)
    return (
      <div className="w-full">
        <Skeleton className="bg-gray-300 h-2 my-2 mr-2 w-full" />
        <Skeleton className="bg-gray-300 h-2 my-2 mr-2 w-full" />
      </div>
    );

  if (property?.owned === false)
    return (
      <div>
        <p className="text-[14px]">Boligen er delt med deg.</p>
      </div>
    );

  if (activeSharing?.length > 2) {
    return (
      <div>
        <p className="text-[14px]">
          Du har delt tilgang med {activeSharing.length} personer.
        </p>
        <Link
          className="text-[14px] underline"
          to={`${dashboardLinkPrefix}/more/private-share`}
        >
          Styr tilgang ›
        </Link>
      </div>
    );
  }

  if (activeSharing?.length > 0) {
    return (
      <div>
        <p className="text-[14px]">Du har delt tilgang til denne boligen:</p>
        <ul className="list-disc list-outside pl-5">
          {activeSharing.map((el) => (
            <li key={el.Id} className="text-[14px]">
              {el?.tenant || ''}
            </li>
          ))}
        </ul>
        <Link
          className="text-[14px] underline"
          to={`${dashboardLinkPrefix}/more/private-share`}
        >
          Gå til deling og tilganger ›
        </Link>
      </div>
    );
  }
  return (
    <div>
      <p className="text-[14px]">
        Er det andre som burde hatt tilgang til {getPropertyAddress(property)}?
        Isåfall kan du dele den med de!
      </p>
      <Link
        className="text-[14px] underline"
        to={`${dashboardLinkPrefix}/more/private-share`}
      >
        Del tilgang ›
      </Link>
    </div>
  );
};

export default PropertySharingDetails;
